/**
 * Stable CSS class names for E2E — pages/SiteManagement/AuthorizationRuleManagement.
 * Containers use `authorization-rules__<element>`; inputs and user-interactable
 * controls use `authorization-rules-input--<name>`.
 *
 * Note: shared atomic dialog components (SCUIAddRoleDialog, SCUIRoleEditDialog,
 * SCUIUpdateRoleDialog) and `SCUIRolesMainRow` live under `atomic/molecules`,
 * so we only expose page-level hooks here (the dialogs are wrapped in a `Box`
 * with a stable class to give tests a reliable container around each).
 */
export const ARM = {
    page: 'authorization-rules-page',
    root: 'authorization-rules',

    /* --- Dialog wrappers (the dialogs themselves are shared atomics) --- */
    dialogAddRole: 'authorization-rules__dialog-add-role',
    dialogBulkAuthorization: 'authorization-rules__dialog-bulk-authorization',
    dialogEndpointSearch: 'authorization-rules__dialog-endpoint-search',
    dialogRoleEdit: 'authorization-rules__dialog-role-edit',
    dialogUpdateRole: 'authorization-rules__dialog-update-role',

    /* --- Header / toolbar --------------------------------------------- */
    titleBox: 'authorization-rules__title-box',
    title: 'authorization-rules__title',
    addRoleBox: 'authorization-rules__add-role-box',
    btnAddRole: 'authorization-rules-input--button-add-role',
    btnBulkAuthorization: 'authorization-rules-input--button-bulk-authorization',
    btnEndpointSearch: 'authorization-rules-input--button-endpoint-search',

    searchBox: 'authorization-rules__search-box',
    inputSearch: 'authorization-rules-input--search',

    /* --- Table -------------------------------------------------------- */
    tablePaper: 'authorization-rules__table-paper',
    tableContainer: 'authorization-rules__table-container',
    table: 'authorization-rules__table',
    tableHead: 'authorization-rules__table-head',
    tableHeadRow: 'authorization-rules__table-head-row',
    tableHeadCell: 'authorization-rules__table-head-cell',
    tableHeadCellRoleName: 'authorization-rules__table-head-cell--role-name',
    tableHeadCellDescription: 'authorization-rules__table-head-cell--description',
    tableHeadCellIsRequestable: 'authorization-rules__table-head-cell--is-requestable',
    tableHeadCellEditRole: 'authorization-rules__table-head-cell--edit-role',
    tableHeadCellAssignManager: 'authorization-rules__table-head-cell--assign-manager',
    tableHeadCellEditUser: 'authorization-rules__table-head-cell--edit-user',
    tableHeadCellEditAuthorization: 'authorization-rules__table-head-cell--edit-authorization',
    tableHeadCellRemoveRole: 'authorization-rules__table-head-cell--remove-role',
    tableBody: 'authorization-rules__table-body',
} as const;

export const armCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
